/*=========================================================================================
  File Name: moduleDataList.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleCapsState.js'
import mutations from './moduleCapsMutations.js'
import actions from './moduleCapsActions.js'
import getters from './moduleCapsGetters.js'

export default {
  isRegistered: false,
  // namespaced: true,
  state,
  mutations,
  actions,
  getters
}

